export default __webpack_public_path__ + "static/media/qac.c05e18e6.png";